import { formatAttributeKey } from './formatAttributeKey.js';

export const formatNestedAttributeKey = (str) => {
  if (!str) return '';
  const parts = String(str).split('.');
  return parts.reduce((acc, part) => {
    const formattedPart = formatAttributeKey(part);
    return `${acc}${acc ? ' > ' : ''}${formattedPart}`;
  }, '');
};
